import React from "react";
import styled from "styled-components";
import { Caption1 } from "../styles/typography";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const Label = styled(Caption1)`
  color: rgb(${(props) => props.theme.colors.neutral200});
  text-transform: uppercase;
`;

const Track = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 6px;
  border-radius: 100px;
  background: rgb(${(props) => props.theme.colors.neutral100});
  overflow: hidden;
`;

const Fill = styled.div`
  height: 100%;
  border-radius: 100px;
  background: rgb(${(props) => props.theme.colors.neutral600});
  width: ${(props) => props.$percent}%;
  transition: width 200ms ease-in-out;
`;

/**
 * @param {{ step:number, total:number, style?:object }} props
 */
const StepProgress = ({ step, total, style }) => {
  const percent = Math.round((step / total) * 100);
  return (
    <Wrapper style={style}>
      <Label>
        Step {step} of {total}
      </Label>
      <Track>
        <Fill $percent={percent} />
      </Track>
    </Wrapper>
  );
};

export default StepProgress;
